import React from 'react';

function InputSection({
  inputMode, setInputMode,
  url, setUrl,
  title, setTitle,
  bodyText, setBodyText,
}) {
  return (
    <section className="input-section">
      {/* 탭 전환 */}
      <div className="input-tabs">
        <button
          className={`input-tab ${inputMode === 'url' ? 'active' : ''}`}
          onClick={() => setInputMode('url')}
        >
          URL로 가져오기
        </button>
        <button
          className={`input-tab ${inputMode === 'text' ? 'active' : ''}`}
          onClick={() => setInputMode('text')}
        >
          직접 붙여넣기
        </button>
      </div>

      {/* URL 입력 */}
      {inputMode === 'url' && (
        <div>
          <input
            className="url-input"
            type="url"
            placeholder="매경 기사 URL을 붙여넣으세요 (예: https://www.mk.co.kr/news/...)"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
          />
        </div>
      )}

      {/* 텍스트 직접 입력 */}
      {inputMode === 'text' && (
        <div className="text-input">
          <input
            type="text"
            placeholder="기사 제목"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <textarea
            placeholder="기사 본문을 여기에 붙여넣으세요..."
            value={bodyText}
            onChange={(e) => setBodyText(e.target.value)}
          />
        </div>
      )}
    </section>
  );
}

export default InputSection;
